
var Modal = require('ffss/ui/Modal');

class IFrame extends Modal {

    defaultOptions(){
        var options = {
            //modal options
            'modalClass': 'iframe-modal',
            'verticalCentered': true,
            'modalSize': 'medium',
            'showFooter': false,
            'showHeader': false,

            //iframe modal options
            'id': window.uniqid(),
            'url': null,
        };
        return Object.assign(super.defaultOptions(),options);
    }

    constructor(options){
        super(options);

        this.url = this.settings.url;

        this.setContent(this.buildContent());

    }

    buildContent(){
        var self = this;

        var $content = this.buildIFrame();

        return $content;
    }

    buildUrl(){
        let url = this.url;
        if(url.indexOf('?') == -1){
            url += '?iframeModalId='+this.id;
        }else{
            url += '&iframeModalId='+this.id;
        }
        return url;
    }
    
    buildIFrame(){
        var self = this;
        this.iframeId = this.id+'-InnerIframe';
        let url = this.buildUrl();

        this.$iframe = $('<iframe/>')
        .attr('id',this.iframeId)
        .attr('src',url)
        .attr('width','100%')
        .attr('height',this.getHeight())
        .css('width','100%')
        .css('height',this.getHeight())
        .on('load',function(event){
            self.onIframeLoad(event);
        });

        return this.$iframe;
    }

    onIframeLoad(event){
    }

}

module.exports = IFrame;